/**
 * Base URL for **server-to-server** API calls (same backend the dashboard uses unless overridden).
 * Set `REACT_APP_INTEGRATION_API_BASE_URL` when the public API host differs from `REACT_APP_API_URL`
 * (e.g. dashboard on www, API on api subdomain).
 */
export function getIntegrationApiBaseUrl(): string {
  const explicit = process.env.REACT_APP_INTEGRATION_API_BASE_URL?.trim();
  const fallback = process.env.REACT_APP_API_URL?.trim() || 'http://localhost:5000/api/v1';
  return (explicit || fallback).replace(/\/+$/, '');
}

export function getShipmentsApiCreateUrl(): string {
  return `${getIntegrationApiBaseUrl()}/shipments/api-create`;
}
